module.exports = __webpack_public_path__ + "img/34_15.c0b44522.png";